<template>
    <section class="content">
        <!-- Cabecera -->
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1>Movimientos de STOCK</h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                            <li class="breadcrumb-item active">Movimientos</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
        <!-- Tabla de movimientos -->
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4">
                    <div id="btn-mover-mercancia" class="info-box mb-3">
                        <router-link to="/movform" class="btn btn-block info-box-icon bg-info elevation-1"><i
                                class="fas fa-right-left"></i></router-link>
                        <div class="info-box-content">
                            <span class="info-box-text">Mover Mercancia</span>
                            <span class="info-box-number">Entrada - Salida</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <div id="btn-motivos" class="info-box mb-3" data-toggle="modal" data-target="#motivoModal">
                        <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-warning elevation-1"><i
                                class="fas fa-file-circle-question"></i></a>
                        <div class="info-box-content">
                            <span class="info-box-text">Motivos</span>
                            <span class="info-box-number">Ver - Gestionar</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <div id="btn-reportes" class="info-box mb-3">
                        <router-link to="/reportes" class="btn btn-block info-box-icon bg-success elevation-1"><i
                                class="fas fa-print"></i></router-link>
                        <div class="info-box-content">
                            <span class="info-box-text">Reporte</span>
                            <span class="info-box-number">Guardar - Imprimir</span>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="card-title">Movimientos de STOCK</h3>
                                </div>

                                <!-- Botón dropdown de filtros -->
                                <div class="col-auto">
                                    <div class="container-fluid mb-3">
                                        <div class="dropdown d-inline-block">
                                            <button ref="toggleFiltros" class="btn btn-info dropdown-toggle"
                                                type="button" id="ddlFiltros" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <i class="fas fa-filter"></i> Filtros
                                            </button>

                                            <div class="dropdown-menu p-3 dropdown-menu-right"
                                                aria-labelledby="ddlFiltros" style="min-width: 280px;" @click.stop>
                                                <div class="form-group">
                                                    <label>Almacén</label>
                                                    <select v-model="almacenSeleccionado" class="form-control">
                                                        <option value="">Todos</option>
                                                        <option v-for="alm in almacenes.filter(a => a.estatus)" :key="alm.id" :value="alm.id">
                                                            {{ alm.descripcion }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <div class="form-group">
                                                    <label>Motivo</label>
                                                    <select v-model="motivoSeleccionado" class="form-control">
                                                        <option value="">Todos</option>
                                                        <option v-for="mot in motivos" :key="mot.id" :value="mot.id">
                                                            {{ mot.nombre }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <div class="form-group">
                                                    <label>Tipo de movimiento</label>
                                                    <select v-model="tipoSeleccionado" class="form-control">
                                                        <option value="">Todos</option>
                                                        <option value="entrada">Entrada</option>
                                                        <option value="salida">Salida</option>
                                                        <option value="traslado">Traslado</option>
                                                    </select>
                                                </div>

                                                <div class="form-group">
                                                    <label>Fecha desde</label>
                                                    <input type="date" v-model="fechaDesde" class="form-control" />
                                                </div>

                                                <div class="form-group">
                                                    <label>Fecha hasta</label>
                                                    <input type="date" v-model="fechaHasta" class="form-control" />
                                                </div>

                                                <div class="d-flex justify-content-between mt-2">
                                                    <button class="btn btn-sm btn-outline-secondary"
                                                        @click="limpiarFiltros">
                                                        Limpiar
                                                    </button>
                                                    <button class="btn btn-sm btn-primary"
                                                        @click="$refs.toggleFiltros.click()">
                                                        Cerrar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <table id="tablaMovimientos" class="table table-bordered table-striped w-100"></table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MotivoModal @saved="fetchMotivos" />
    </section>
</template>

<script setup>
import { ref, computed, onMounted, watch, onUnmounted } from 'vue'
import api from '@/services/api'
import { tutorial } from "@/plugins/tutorial";
import MotivoModal from '@/components/MotivoModal.vue'

const almacenes = ref([])
const motivos = ref([])
const movimientos = ref([])

// filtros
const almacenSeleccionado = ref('')
const motivoSeleccionado = ref('')
const tipoSeleccionado = ref('')
const fechaDesde = ref('')
const fechaHasta = ref('')

// 1. Combina entradas, salidas y traslados
onMounted(async () => {
    const [entradas, salidas, traslados, almac, mot] = await Promise.all([
        api.get('/entrada'),
        api.get('/salida'),
        api.get('/traslados'),
        api.get('/almacen'),
        api.get('/motivos')
    ])

    almacenes.value = almac.data
    motivos.value = mot.data

    // Normalizar cada tipo
    const eNorm = entradas.data.map(i => ({
        ...i,
        tipo: 'entrada',
        almacen_origen_id: null,
        almacen_destino_id: i.almacen_id
    }))

    const sNorm = salidas.data.map(i => ({
        ...i,
        tipo: 'salida',
        almacen_origen_id: i.almacen_id,
        almacen_destino_id: null
    }))

    const tNorm = traslados.data.map(i => ({
        ...i,
        tipo: 'traslado',
        almacen_origen_id: i.almacen_origen_id,
        almacen_destino_id: i.almacen_destino_id
    }))

    movimientos.value = [...eNorm, ...sNorm, ...tNorm]
})

onMounted(() => {
    tutorial.set(iniciarTutorial);
});

onUnmounted(() => {
    if (dtInstance) {
        window.$('#tablaMovimientos tbody').off('click.tutorial');
        dtInstance.destroy();
        dtInstance = null;
    }
    tutorial.set(null);
});

// 2. Datos combinados y ordenados
const datosCombinados = computed(() =>
    movimientos.value
        .map(m => ({ ...m, fechaObj: new Date(m.fecha) }))
        .sort((a, b) => b.fechaObj - a.fechaObj)
)

// 3. Filtros
const movimientosFiltrados = computed(() =>
    datosCombinados.value.filter(m => {
        if (
            tipoSeleccionado.value &&
            m.tipo !== tipoSeleccionado.value
        ) return false

        if (
            almacenSeleccionado.value &&
            m.almacen_origen_id !== +almacenSeleccionado.value &&
            m.almacen_destino_id !== +almacenSeleccionado.value
        ) return false

        if (
            motivoSeleccionado.value &&
            m.motivo_id !== +motivoSeleccionado.value
        ) return false

        if (fechaDesde.value && m.fechaObj < new Date(fechaDesde.value))
            return false
        if (fechaHasta.value && m.fechaObj > new Date(fechaHasta.value))
            return false

        return true
    })
)

// 4. Agrupar y armar objeto final por código
const movimientosAgrupados = computed(() => {
    const map = {}
    movimientosFiltrados.value.forEach(item => {
        const key = item.codigo
        if (!map[key]) {
            const origen = item.almacen_origen_id
                ? almacenes.value.find(a => a.id === item.almacen_origen_id)
                    .descripcion
                : '-'
            const destino = item.almacen_destino_id
                ? almacenes.value.find(a => a.id === item.almacen_destino_id)
                    .descripcion
                : '-'

            map[key] = {
                codigo: key,
                numcontrol: item.numcontrol,
                fecha: item.fecha,
                origen,
                destino,
                motivo: item.motivo.nombre,
                status: item.status,
                tipo: item.tipo,
                detalles: []
            }
        }
        map[key].detalles.push({
            producto_id: item.producto_id,
            cantidad: item.cantidad,
            observ: item.observ
        })
    })
    // Convertimos a array y ordenamos por fecha descendente
    return Object.values(map).sort((a, b) => {
        return new Date(b.fecha) - new Date(a.fecha)
    })
})

// 5. Limpiar filtros
function limpiarFiltros() {
    almacenSeleccionado.value = ''
    motivoSeleccionado.value = ''
    tipoSeleccionado.value = ''
    fechaDesde.value = ''
    fechaHasta.value = ''
}
function fetchMotivos() {
    console.log('Motivo guardado')
}

// 6. DataTable
let dtInstance = null
function initTable() {
    const data = movimientosAgrupados.value
    if (!dtInstance) {
        dtInstance = $('#tablaMovimientos').DataTable({
            data,
            order: [[1, 'desc']],
            columns: [
                { 
                    data: 'codigo', 
                    title: 'Código',
                    render: (data, type, row) => row.status === 'anulado' ? `${data} <span class="badge badge-danger">Anulado</span>` : data
                },
                { data: 'fecha', title: 'Fecha' },
                { data: 'origen', title: 'Almacén Origen' },
                { data: 'destino', title: 'Almacén Destino' },
                { data: 'motivo', title: 'Motivo' },
                {
                    data: null,
                    title: 'Acciones',
                    className: 'text-center',
                    render: row => {
                        // row.tipo  → 'entrada' | 'salida' | 'traslado'
                        // row.numcontrol → e.g. '0001'
                        const url = `/movimientos/${row.tipo}/${row.numcontrol}`
                        return `
                                <a 
                                    href="${url}"
                                    class="btn btn-sm btn-info ver-detalles-tutorial"
                                >
                                    Ver detalles
                                </a>
                                `
                    }
                }
            ],
            responsive: true,
            autoWidth: false,
            pageLength: 10,
            lengthChange: false,
            pagingType: 'numbers',
            language: {
                url: 'https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json'
            },
            createdRow: function (row, data) {
                if (data.status === 'anulado') {
                    $(row).addClass('table-danger');
                }
            },
            dom:
                '<"row mb-3"<"col-12 col-md-6"f>>' +
                't' +
                '<"row mt-3"<"col-12 text-center"i>>' +
                '<"row"<"col-12 d-flex justify-content-center"p>>',
            drawCallback() {
                $('#tablaMovimientos tbody')
                    .off('click', '.ver-detalles')
                    .on('click', '.ver-detalles', e => {
                        const codigo = $(e.currentTarget).data('codigo')
                        // redirige o abre vista detalles
                        console.log('ver detalles de', codigo)
                    })
            }
        })
    } else {
        dtInstance.clear()
        dtInstance.rows.add(data)
        dtInstance.draw(false)
    }
}

// 7. Observer para refrescar
watch(
    [
        movimientosFiltrados,
        () => almacenSeleccionado.value,
        () => motivoSeleccionado.value,
        () => tipoSeleccionado.value,
        () => fechaDesde.value,
        () => fechaHasta.value
    ],
    initTable
)

function iniciarTutorial() {
    const steps = [
        {
            element: '#btn-mover-mercancia',
            title: 'Mover Mercancía',
            text: 'Haz clic aquí para registrar entradas, salidas o traslados.',
            position: 'bottom'
        },
        {
            element: '#btn-motivos',
            title: 'Gestionar Motivos',
            text: 'Aquí puedes ver y crear los motivos para los movimientos de inventario.',
            position: 'bottom'
        },
        {
            element: '#btn-reportes',
            title: 'Reportes',
            text: 'Genera reportes detallados de los movimientos de stock.',
            position: 'bottom'
        },
        {
            element: '#ddlFiltros',
            title: 'Filtrar Movimientos',
            text: 'Usa este botón para filtrar por almacén, tipo de movimiento o fechas.',
            position: 'bottom'
        },
        {
            element: '#tablaMovimientos',
            title: 'Historial de Movimientos',
            text: 'Aquí verás el listado de todos los movimientos realizados.',
            position: 'top'
        }
    ];

    const table = window.$('#tablaMovimientos');
    const isCollapsed = table.hasClass('collapsed');
    const actionsVisible = table.find('tbody tr:first-child td:last-child').is(':visible');

    if (isCollapsed && !actionsVisible) {
        const firstRow = table.find('tbody tr:first-child');

        if (firstRow.hasClass('parent')) {
            firstRow.find('td:first-child').click();
        }

        steps.push({
            element: '#tablaMovimientos tbody tr:first-child td:first-child',
            title: 'Ver Detalles',
            text: 'En pantallas pequeñas, haz clic en el símbolo (+) para ver las acciones.',
            position: 'bottom',
            tooltipClass: 'hide-next-btn'
        });

        firstRow.off('click.tutorial').on('click.tutorial', function () {
            setTimeout(() => {
                const tooltip = document.querySelector('.introjs-tooltip');
                if (tooltip) {
                    tooltip.classList.toggle('hide-next-btn', !window.$(this).hasClass('parent'));
                }
            }, 200);
        });

        steps.push({
            element: '.dtr-details .ver-detalles-tutorial',
            title: 'Detalle del Movimiento',
            text: 'Haz clic para ver la información completa del movimiento.',
            position: 'left'
        });
    } else {
        steps.push({
            element: '#tablaMovimientos .ver-detalles-tutorial',
            title: 'Detalle del Movimiento',
            text: 'Haz clic para ver la información completa del movimiento.',
            position: 'left'
        });
    }

    tutorial.start(steps);
}
</script>

<style>
/* Transición opcional si abres la dropdown con Vue en lugar de Bootstrap JS */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.hide-next-btn .introjs-nextbutton,
.hide-next-btn .introjs-nextBtn {
    display: none !important;
}
</style>
